"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsKeys = void 0;
var SettingsKeys;
(function (SettingsKeys) {
    SettingsKeys["DUMMY"] = "DUMMY";
    SettingsKeys["SIGNATURE_TTL"] = "SIGNATURE_TTL";
    SettingsKeys["EXCLUDED_MERCHANTS"] = "EXCLUDED_MERCHANTS";
})(SettingsKeys || (exports.SettingsKeys = SettingsKeys = {}));
//# sourceMappingURL=settings.js.map